// src/components/snackbar/SnackbarProvider.tsx
import React, { createContext, useContext, useState, useCallback } from 'react';

interface SnackbarMessage {
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
}

interface SnackbarContextType {
  showSnackbar: (message: SnackbarMessage) => void;
}

const SnackbarContext = createContext<SnackbarContextType | undefined>(undefined);

export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [snackbar, setSnackbar] = useState<SnackbarMessage | null>(null);

  const showSnackbar = useCallback((message: SnackbarMessage) => {
    setSnackbar(message);
    setTimeout(() => setSnackbar(null), 5000); // Hide after 5 seconds
  }, []);

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {children}
      {snackbar && (
        <div
          className={`fixed bottom-4 right-4 p-4 rounded-md shadow-lg ${snackbar.type === 'success' ? 'bg-green-500' :
              snackbar.type === 'error' ? 'bg-red-500' :
                snackbar.type === 'warning' ? 'bg-yellow-500' : 'bg-blue-500'
            } text-white`}
        >
          {snackbar.message}
        </div>
      )}
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return context;
};